import { translate } from "../i18n";
import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';
import { X, ArrowUpRight } from '@phosphor-icons/react';
const KEY = 'pedrazzini-natale-2026-santa-seen';
export default function SeasonalPopup() {
  const [open, setOpen] = useState(false);
  const dialog = useRef(null);
  useEffect(() => {
    if (window.location.hash || window.location.search || Date.now() >= Date.parse('2026-12-26T00:00:00+01:00')) return;
    try {
      if (sessionStorage.getItem(KEY)) return;
    } catch {}
    const timer = setTimeout(() => {
      setOpen(true);
      try {
        sessionStorage.setItem(KEY, '1');
      } catch {}
    }, 1800);
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    if (!open) return;
    const previousFocus = document.activeElement;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.current.showModal();
    return () => {
      document.body.style.overflow = overflow;
      if (previousFocus?.isConnected) previousFocus.focus();
    };
  }, [open]);
  if (!open) return null;
  return createPortal(<dialog ref={dialog} className="christmas-modal" aria-labelledby="seasonal-popup-title" aria-describedby="seasonal-popup-description" onCancel={() => setOpen(false)} onClick={event => {
    if (event.target !== event.currentTarget) return;
    const rect = event.currentTarget.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) setOpen(false);
  }}>
    <button className="christmas-modal-close" onClick={() => setOpen(false)} aria-label={translate("Chiudi proposta natalizia")} autoFocus><X size={24} /></button>
    <div className="christmas-modal-grid">
      <div className="christmas-modal-art"><img src="/images/santa-sign-popup.webp" width="640" height="640" alt={translate("Babbo Natale regge il cartello delle proposte natalizie")} /></div>
      <div className="christmas-modal-copy">
        <p className="christmas-modal-label">{translate("QUESTO MESE \xB7 NATALE 2026")}</p>
        <h2 id="seasonal-popup-title">{translate("Il Natale si prepara adesso.")}</h2>
        <p id="seasonal-popup-description">{translate("Calendari, auguri e regali personalizzati per aziende e privati.")}</p>
        <Link className="christmas-modal-cta" to="/proposte/natale-2026/" onClick={() => setOpen(false)}>{translate("Scopri le proposte ")}<ArrowUpRight size={22} /></Link>
      </div>
    </div>
  </dialog>, document.body);
}
